/** 
 * @typedef {"Language" | "CentralPointHash" | "domain" | "username" | "password" | "screenType" | "ForceMobileMode"} FormDataKey
 * @type {{language: FormDataKey, centralPointHash: FormDataKey, domain: FormDataKey, username: FormDataKey, password: FormDataKey, screenType: FormDataKey, ForceMobileMode: FormDataKey}}
 */
export const FormDataKey = {
    language: "Language",
    centralPointHash: "CentralPointHash",
    domain: "domain",
    username: "username",
    password: "password",
    screenType: "screenType",
    ForceMobileMode: "ForceMobileMode"
}

/** 
 * @typedef {0 | 1 | 2} AuthServiceType
 * @type {{none: AuthServiceType, oauth2: AuthServiceType, saml2: AuthServiceType }}
 */
export const AuthServiceType = {
    none: 0,
    oauth2: 1,
    saml2: 2
}

/**
 * @typedef {Object} AuthService
 * @property {string} id
 * @property {string} description
 * @property {AuthServiceType} serviceType
 * @property {boolean} hasSecret
 * @property {boolean} isEnabled
 * @property {boolean} allowRememberMe
 * @property {boolean} adminOnly
 */

/** 
 * @typedef {"both" | "external" | "basic" | "none"} AuthType
 * @type {{both: AuthType, external: AuthType, basic: AuthType, none: AuthType}}
 */
export const AuthType = {
    both: "both",
    external: "external",
    basic: "basic",
    none: "none"
}